import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "navbar mobile-navbar is-hidden-desktop is-hidden-tablet",
  "aria-label": "main navigation"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "navbar-brand" }
const _hoisted_4 = { class: "brand-start" }

import { computed } from "vue";
import { mapState } from "vuex";

export default /*@__PURE__*/_defineComponent({
  __name: 'MobileNavbar',
  props: {
  isOpen: {
    type: Boolean,
    default: false,
  },

},
  emits: ['toggle'],
  setup(__props, { emit: __emit }) {

const props = __props
const user = computed(()=>{
  return mapState(['user'])
});
const emit = __emit

return (_ctx: any,_cache: any) => {
  return (user.value)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["navbar-burger", [props.isOpen && 'is-active']]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle')))
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("span", null, null, -1),
                _createElementVNode("span", null, null, -1),
                _createElementVNode("span", null, null, -1)
              ]))], 2)
            ]),
            _renderSlot(_ctx.$slots, "brand")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})